<template>
    <div
        class="p-4 rounded-xl bg-white border border-gray-200 shadow-xs hover:border-transparent hover:ring-2 hover:ring-booking-form-theme-main-background-color"
    >
        <slot />
    </div>
</template>
